// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cn-skeleton-element{--ab-canyon-skeleton-element-color-bg:var(--ab-canyon-color-neutral-light);animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite;background-color:var(--ab-canyon-color-neutral-light);background-color:var(--ab-canyon-skeleton-element-color-bg)}@keyframes pulse{50%{opacity:.5}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
